import React from 'react';
import {
  TrainingOverview,
  OverviewContent,
  OverviewTitle,
  OverviewText,
  OverviewActions,
  TrainingPanel,
  PanelHeader,
  PanelStatus,
  TrainingStatusList,
  TrainingStatusItem,
  StatusIcon,
} from './Overview.styles';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import SecondaryButton from '../../../Components/Buttons/SecondaryButton/SecondaryButton.component';
import { useNavigate } from 'react-router-dom';
import {
  FaUserPlus,
  FaBookOpen,
  FaChartBar,
  FaCertificate,
} from 'react-icons/fa';
const Overview = () => {
  const navigate = useNavigate();
  return (
    <TrainingOverview>
      <OverviewContent>
        {/* <p className="eyebrowHeader">Training Management</p> */}

        <OverviewTitle>
          Keep Your Company&apos;s Training Organized
        </OverviewTitle>

        <OverviewText>
          Managing workplace training should not mean chasing certificates,
          spreadsheets, and individual course records. A Yoda Safety Services
          company account gives you one place to manage employees, assign safety
          training, and follow their progress.
        </OverviewText>

        <OverviewText>
          See who has been assigned training, who has completed it, and where
          follow-up may be needed. When employees complete their courses, your
          company can stay informed and keep their certificates accessible for
          your records.
        </OverviewText>

        <OverviewActions>
          <PrimaryButton
            functionName={() => navigate('/company-signup')}
            span="Register Your Company"
          />

          <SecondaryButton
            functionName={() => navigate('/training')}
            span="View Available Courses"
          />
        </OverviewActions>
      </OverviewContent>

      <TrainingPanel>
        <PanelHeader>
          <div>
            {/* <PanelEyebrow>Company Dashboard</PanelEyebrow> */}
            <h3>Training at a Glance</h3>
          </div>

          <PanelStatus>Live Tracking</PanelStatus>
        </PanelHeader>

        <TrainingStatusList>
          <TrainingStatusItem>
            <StatusIcon>
              <FaUserPlus />
            </StatusIcon>

            <div>
              <strong>Manage Employees</strong>
              <span>
                Add and organize the people training with your company.
              </span>
            </div>
          </TrainingStatusItem>

          <TrainingStatusItem>
            <StatusIcon>
              <FaBookOpen />
            </StatusIcon>

            <div>
              <strong>Assign Courses</strong>
              <span>Select the training each employee needs to complete.</span>
            </div>
          </TrainingStatusItem>

          <TrainingStatusItem>
            <StatusIcon>
              <FaChartBar />
            </StatusIcon>

            <div>
              <strong>Track Progress</strong>
              <span>See training status across employees and courses.</span>
            </div>
          </TrainingStatusItem>

          <TrainingStatusItem>
            <StatusIcon>
              <FaCertificate />
            </StatusIcon>

            <div>
              <strong>Access Certificates</strong>
              <span>Keep completed training records easier to find.</span>
            </div>
          </TrainingStatusItem>
        </TrainingStatusList>
      </TrainingPanel>
    </TrainingOverview>
  );
};

export default Overview;
